module.exports = __webpack_public_path__ + "img/austinpowderlogoblack-min.c05c9017.png";